export default "__VITE_ASSET__803aceee__"